const NUM = /^\d+$/
const STEP = /^\*\/([1-9]\d*)$/
const DAY_LIST = /^[0-6](,[0-6])*$/

const unknown = (raw) => ({ repeat: 'unknown', raw })

// Read a five-field cron into the shapes the picker can express in plain English.
// Anything else comes back as `unknown` carrying the original text, so a schedule
// we cannot describe is still never corrupted by a save — and never shown as cron.
export function cronToParts(cron) {
  const raw = String(cron ?? '')
  const fields = raw.trim().split(/\s+/)
  if (fields.length !== 5) return unknown(raw)
  const [minute, hour, dayOfMonth, month, weekday] = fields
  if (month !== '*') return unknown(raw)

  const everyMinutes = STEP.exec(minute)
  if (everyMinutes && hour === '*' && dayOfMonth === '*' && weekday === '*') {
    return { repeat: 'custom', unit: 'minutes', every: Number(everyMinutes[1]), minute: 0, raw }
  }
  if (!NUM.test(minute)) return unknown(raw)
  const min = Number(minute)

  const everyHours = STEP.exec(hour)
  if (everyHours && dayOfMonth === '*' && weekday === '*') {
    return { repeat: 'custom', unit: 'hours', every: Number(everyHours[1]), minute: min, raw }
  }
  if (hour === '*' && dayOfMonth === '*' && weekday === '*') {
    return { repeat: 'hourly', minute: min, raw }
  }
  if (!NUM.test(hour)) return unknown(raw)
  const hr = Number(hour)

  if (dayOfMonth === '*' && weekday === '*') return { repeat: 'daily', minute: min, hour: hr, raw }
  if (dayOfMonth === '*' && weekday === '1-5') {
    return { repeat: 'weekdays', minute: min, hour: hr, raw }
  }
  if (dayOfMonth === '*' && DAY_LIST.test(weekday)) {
    const weekdays = [...new Set(weekday.split(',').map(Number))].sort()
    return { repeat: 'weekly', minute: min, hour: hr, weekdays, raw }
  }
  if (weekday === '*' && NUM.test(dayOfMonth)) {
    return { repeat: 'monthly', minute: min, hour: hr, dayOfMonth: Number(dayOfMonth), raw }
  }
  return unknown(raw)
}
